import React from 'react'
import Icon from '../../misc/Icons'
import { getQuestionBodyLabel } from '../../../utils/getQuestionBodyLabel'
import QuestionCountBadge from '../../uiKit/QuestionCountBadge'

// The child rows shared by the pack and folder previews: subfolders first, then
// sets, then loose questions. Which children belong here and in what order is
// the caller's business (each preview selects and sorts its own from the store);
// this only renders them, or the caller's empty copy when there are none.
function SearchPreviewChildList({
  folders, sets, questions, emptyLabel,
}) {
  const folderRows = folders || []
  const setRows = sets || []
  const questionRows = questions || []

  if (folderRows.length === 0 && setRows.length === 0 && questionRows.length === 0) {
    return (
      <div className='searchPreviewList-empty'>
        <span>{emptyLabel}</span>
      </div>
    )
  }

  return (
    <div className='searchPreviewList'>
      {folderRows.map((f) => (
        <div key={f.id} className='searchPreviewList-row searchPreviewList-row--folder'>
          <div className='searchPreviewList-row-icon'>
            <Icon name={f.readOnly ? 'folder-isbe' : 'folder'} />
          </div>
          <div className='searchPreviewList-row-name'>{f.name || 'Untitled Folder'}</div>
        </div>
      ))}
      {setRows.map((s) => (
        <div key={s.id} className='searchPreviewList-row searchPreviewList-row--set'>
          <div className='searchPreviewList-row-icon'>
            <QuestionCountBadge
              color='blueLight'
              size='small'
              questionCount={Array.isArray(s.questions) ? s.questions.length : 0}
            />
          </div>
          <div className='searchPreviewList-row-name'>{s.name || 'Untitled Set'}</div>
        </div>
      ))}
      {questionRows.map((q) => (
        <div key={q.id} className='searchPreviewList-row searchPreviewList-row--question'>
          <div className='searchPreviewList-row-icon'>
            <QuestionCountBadge color='blueLight' size='small' questionCount='–' />
          </div>
          <div className='searchPreviewList-row-name'>{getQuestionBodyLabel(q) || 'Untitled Question'}</div>
        </div>
      ))}
    </div>
  )
}

export default SearchPreviewChildList
